import client from "shared/setupClient";
import { loader } from "graphql.macro";

const removeChecklistItemMutation = loader("graphql/mutations/checklist/removeChecklistItem.graphql");

export default function removeChecklistItemAction(checklistId, item) {
    const { sequenceNumber } = item;
    const variables = { checklistId, checklistTaskSequenceNumber: sequenceNumber };
    return client.mutate({
        mutation: removeChecklistItemMutation, variables
    });
}